/** Identity of a basket line: the item plus the exact option set. Options are
 *  sorted so that picking express-then-starch and starch-then-express land on
 *  the same line instead of two that look identical in the list.
 *
 *  Here rather than in `state/cart.tsx`, which is where it was written and is
 *  still the only place that *builds* a basket with it: the http adapter has to
 *  rebuild the same key for a line read back off a placed order, and an adapter
 *  importing a React context module to get one pure function is a dependency
 *  pointing the wrong way. One rule, one home, imported by both. */
export function lineKey(itemId: string, optionIds: string[]): string {
  return optionIds.length ? `${itemId}#${optionIds.toSorted().join(',')}` : itemId
}
